<template>
  <div class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
      <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
        <tr v-for="(value, key) in filteredData" :key="key">
          <th class="px-4 py-2 bg-gray-50 dark:bg-gray-800 text-left font-medium text-gray-700 dark:text-gray-300 w-1/3">
            {{ formatKey(key) }}
          </th>
          <td class="px-4 py-2 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-300">
            <template v-if="isObject(value)">
              <pre class="text-xs bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-300 p-2 rounded overflow-auto max-h-32">{{ JSON.stringify(value, null, 2) }}</pre>
            </template>
            <template v-else>
              {{ formatValue(value) }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  exclude: {
    type: Array,
    default: () => []
  }
});

const filteredData = computed(() => {
  if (!props.data) return {};

  const result = { ...props.data };

  // Remove campos explicitamente excluídos
  props.exclude.forEach(key => {
    delete result[key];
  });

  // Remove campos INT se existir versão _formatted
  // Ex: se existe 'amount_formatted', remove 'amount'
  Object.keys(result).forEach(key => {
    if (key.endsWith('_formatted')) {
      const originalKey = key.replace('_formatted', '');
      if (result[originalKey] !== undefined) {
        delete result[originalKey];
      }
    }
  });

  return result;
});

const formatKey = (key) => {
  // Remove sufixo '_formatted' antes de formatar
  const cleanKey = key.replace(/_formatted$/, '');

  return cleanKey
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const isObject = (value) => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};

const formatValue = (value) => {
  if (value === null || value === undefined) {
    return 'N/A';
  }
  if (typeof value === 'boolean') {
    return value ? 'Sim' : 'Não';
  }
  if (Array.isArray(value) && value.length === 0) {
    return 'Nenhum registro';
  }
  return value;
};
</script>
